module.exports = __webpack_public_path__ + "img/108.9.f1c8a90c.png";